/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getOtherdetailsData } from '../store/slices/otherDetailsSlice'

export const useOtherDetails = () => {
  const dispatch = useDispatch()
  const otherdetailsData = useSelector((state) => state.otherdetails)

  useEffect(() => {
    if (otherdetailsData.status === 'idle') {
      dispatch(getOtherdetailsData())
    }
  }, [])

  return otherdetailsData?.otherdetailsData
}
